<template>
  <body class="mob-overflow">
    <div class="reg_suc_mainview_div position_fixed">
      <div class="common--header reg_suc_padding">
        <h4 class="mob_navHeader desk_navHeader textWhiteColor">REGISTRATION</h4>
      </div>
      <b-container class="bv-example-row reg_suc_cont_ht mob_col_padding">
        <b-row align-h="center" class="dev_lr_margin row_height">
          <b-col class="xs_col col-sm-10 col-md-7 col-lg-5 col_padding dev_position">
            <b-container class="containerstyle reg_suc_containerstyle">
              <div class="successMsgdiv">
                <img src="images/Success.svg" style="vertical-align: middle; align-items: center;" />
              </div>
              <div class="successMsgdiv">
                <label class="thankyoulabel">{{ this.successMsg }}</label>
              </div>
              <div class="reg_suc_goHomeDivStyle reg_suc_bottom desk_mar_top footer_bottom">
                <div class="continue__controls">
                  <b-row align-h="center">
                    <b-col class="xs_col col-sm-8 col-md-6 col-lg-8">
                      <b-button type="login" variant="" v-on:click="onContinue">HOME</b-button>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-container>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <Footer></Footer>
  </body>
</template>

<script>
import { store } from "@/store.js";
import Footer from "@/components/footer";

export default {
  name: "",
  components: {
    Footer,
  },
  data() {
    return {
      successMsg: "",
      store: store,
    };
  },
  methods: {
    onContinue(evt) {
      evt.preventDefault();
      this.$router.push({ path: "/app-home" });
    },
  },
  mounted() {
    this.successMsg = store.registrationSuccessResponse;
  },
};
</script>
